import { useMutation } from "@shared/lib/hooks";
import { OrganisationService } from "../services/organisation.service";
import { ICreateOrganisationRequest } from "../types";

export function useEditOrganisation() {
  const {
    mutate: edit,
    isLoading: isEditing,
    isSuccess: isEdited,
    error: editOrganisationError,
  } = useMutation<ICreateOrganisationRequest>({
    mutationFn: (organisation: ICreateOrganisationRequest) =>
      OrganisationService.editOrganisation(organisation),
    options: {
      skipInvalidation: false,
    },
  });

  return {
    edit,
    isEditing,
    isEdited,
    editOrganisationError,
  };
}
